import { get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "modules/market-tools/model"
import { Creators as HomeLayoutCreators } from "modules/home-layout/model"
import { getIsOpPro } from "modules/account-root/selectors"
import { getSelectedModelId, getSelectedModelName, getSelectedScreen } from "./selectors"
import { getIsModelInQueryString } from "selectors/queryString"
import withUrlParams from "hocs/withUrlParams"
import { MODELS_QUERY } from "resources/models"

export default withUrlParams(createModule({
  view,
  externalProps: (state) => ({
    account: get(state, "global.selected.account"),
    accountId: get(state, "global.selected.accountId"),
  }),
  required: ["account", "accountId"],
  data: [MODELS_QUERY, {
    resource: "marketToolsModelPreferences",
    url: ({ account, accountId }) => {
      return {
        id: `marketToolsModelPreferences-${account}`,
        url: "/api/users/me/preferences",
        payload: {
          items: [{
            type: "marketToolsLastModelUsed",
            key: account,
            accountId,
          }],
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    selectedScreen: getSelectedScreen(state, props),
    modelId: getSelectedModelId(state, props),
    isModelInQueryString: getIsModelInQueryString(state, props),
    modelName: getSelectedModelName(state, props),
    isOpPro: getIsOpPro(state, props),
  }),
  actions: {
    ...Creators,
    disableSecurityModelSelector: HomeLayoutCreators.disableSecurityModelSelector,
    setHomeLayoutModel: HomeLayoutCreators.setModel,
  },
}))
